import { fieldConfig } from "@autoform/zod";
import * as z from "zod";
import { RESOLVER_OPTIONS } from "../common/enums";

export const remoteGraderShape = {
	retailResolver: z
		.enum(RESOLVER_OPTIONS)
		.default("human-agent")
		.check(
			fieldConfig({
				fieldType: "singleselect",
				description: "The resolver that will be used in all retail flows",
			}),
		)
		.describe("Retail Resolver"),
	homeResolver: z
		.enum(RESOLVER_OPTIONS)
		.default("human-agent")
		.check(
			fieldConfig({
				fieldType: "singleselect",
				description: "Resolver that will be used for all from-home flows",
			}),
		)
		.describe("From-Home Resolver"),
	cacheResolver: z.boolean().default(false).describe("Use Cache"),
	vaScreening: z
		.boolean()
		.default(false)
		.check(fieldConfig({ description: "Ask the Vision Agent to screen the photos before grading" }))
		.describe("VA Screening"),
};

export const remoteGraderSchema = z.object(remoteGraderShape);

export type RemoteGraderConfig = z.infer<typeof remoteGraderSchema>;
